module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2s"
  }, [_c('a', {
    attrs: {
      "id": "page_viii"
    }
  }), _c('a', {
    attrs: {
      "id": "page_ix"
    }
  }), _c('a', {
    attrs: {
      "id": "ill"
    }
  }), _c('span', {
    staticClass: "small"
  }, [_vm._v("ILLUSTRATIONS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/introduction#figI.1"
    }
  }, [_vm._v("Figure I.1. Signers’ Island")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter01#fig1.1"
    }
  }, [_vm._v("Figure 1.1. Percentage of Speeches in Which “American Revolution” Was Mentioned, by Presidential Election Cycle")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter01#fig1.2"
    }
  }, [_vm._v("Figure 1.2. Number of “American Revolution” Mentions per Speech, by Presidential Election Cycle")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter01#fig1.3"
    }
  }, [_vm._v("Figure 1.3. Mentions of “Founding Fathers” per Speech, by Presidential Election Cycle")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter01#fig1.4"
    }
  }, [_vm._v("Figure 1.4. Mentions of “More Perfect Union” per Speech, by Presidential Election Cycle")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter01#fig1.5"
    }
  }, [_vm._v("Figure 1.5. Mentions of “Created Equal” per Speech, by Presidential Election Cycle")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter03#fig3.1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Figure 3.1. Independence Hall")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter03#fig3.2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Figure 3.2. Ceremonial Reading of the Declaration behind Independence Hall")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter03#fig3.3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Figure 3.3. The First White House")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter03#fig3.4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Figure 3.4. The National Constitution Center")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter03#fig3.5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Figure 3.5. Colonial Williamsburg’s Revolutionary City")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter03#fig3.6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Figure 3.6. George Washington in Bronze and Glass in Mount Vernon’s Ford Orientation Center")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter03#fig3.7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Figure 3.7. Monticello")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter03#fig3.8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Figure 3.8. Prince Estabrook Memorial Marker")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter03#fig3.9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Figure 3.9. Boston Tea Party Ships & Museum")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter03#fig3.10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Figure 3.10. National Liberty Museum")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter04#fig4.1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Figure 4.1. Stealing a National Treasure")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "id": "page_x"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter04#fig4.2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Figure 4.2. Mount Vernon as Stage Prop")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter04#fig4.3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Figure 4.3. The Patriotic Benjamin Martin")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter04#fig4.4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Figure 4.4. Revolutionary Rage")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter04#fig4.5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Figure 4.5. Gone with the Revolution")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter04#fig4.6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Figure 4.6. Sarah and James Share a Rare Agreeable Moment")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter04#fig4.7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Figure 4.7. Phillis Wheatley and Moses")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter04#fig4.8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Figure 4.8. Assertive Sarah")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter04#fig4.9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Figure 4.9. John Adams in the Continental Congress")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter04#fig4.10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Figure 4.10. “Half-Fed Slaves Building Our Nation’s Capital”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter05#fig5.1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Figure 5.1. A Battle of Authenticity")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-be3f3abe","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/illustrations.vue
// module id = 72
// module chunks = 0